import ReservationUrl           from "../../../domain/reservation/url/ReservationUrl";
import ReservationUrlRepository from "../../../domain/reservation/url/ReservationUrlRepository";
import ReservationUrlDataSource from "../../../infrastructure/datasource/reservation/ReservationUrlDataSource";

class GetReservationUrl {
  constructor(private readonly repository: ReservationUrlRepository = new ReservationUrlDataSource()) {
  }

  public async execute(result: (ReservationUrl) => void, loading: (value: boolean) => void) {
    loading(true);
    try {
      const response = await this.repository.findBy();
      result(new ReservationUrl(response.data.url));
    } catch (e) {
      result(new ReservationUrl());
    } finally {
      loading(false);
    }
  }
}

export default GetReservationUrl;
